import { PV, SUM } from '__jsLibs/EXCEL';
const gettersPurchaseOrPass = {
	CanyouafforditYourGoal(state, getters) {
		const B6 = +state.result['downpayment'] / 100;
		const B11 = +state.result['interest_rate'] / 100;
		const B13 = +getters.ofPayments;
		const B49 = +state.constants['back_end_debt_ratio'] / 100;

		const B58 = +state.constants['your_current_annual_salary'] / 12;
		const B51 = +state.constants['rent_revenue_adjustment_by_banks'] / 100;
		const E10 = +getters.TotalRevenues;

		const sum = SUM([
			+state.constants['car_note_monthly_payment'],
			+state.constants['credit_card_payments'],
			+state.constants['first_home_month_mortgage_payment'],
			+state.constants['other_debt_monthly_payment'],
			+state.constants['student_loans_monthly_payment']
		]);
		const pv = -PV(B11 / 12, B13, B49 * (B58 + B51 * E10) - sum);

		return pv / (1 - B6);
	},
	CanyouafforditActual(state, getters) {
		if (state.result['home_price'] && state.result['home_price'] !== '') {
			return +state.result['home_price'];
		}
		return 0;
	},
	CanyouafforditDecision(state, getters) {
		if (getters.CanyouafforditYourGoal && getters.CanyouafforditActual) {
			return +getters.CanyouafforditYourGoal > +getters.CanyouafforditActual
				? 'Purchase'
				: 'Pass';
		}
		return '';
	},
	CashonCashReturnGreaterThanActual(state, getters) {
		const E10 = +getters.TotalRevenues;
		const E21 = +getters.TotalOperatingExpensesCosts;
		const E34 = +getters.MonthlyPaymentWPMI;
		const B23 = +getters.TotalUpfrontInvestment;
		return (100 * (12 * SUM([
			E10, -E21, -E34
		]))) / B23;
	},
	CashonCashReturnGreaterDecision(state, getters) {
		if (
			getters.CashonCashReturnGreaterThanActual
			&& state.result['cash_on_cash_return_gt']
			&& state.result['cash_on_cash_return_gt'] !== ''
		) {
			return +getters.CashonCashReturnGreaterThanActual
				> +state.result['cash_on_cash_return_gt']
				? 'Purchase'
				: 'Pass';
		}
		return '';
	},
	MonthlyRentsPriceGreaterThanActual(state, getters) {
		if (
			state.result['home_price']
			&& state.result['home_price'] !== ''
			&& getters.TotalRevenues
			&& getters.TotalRevenues !== 0
		) {
			return (100 * +getters.TotalRevenues) / +state.result['home_price'];
		}
		return 0;
	},
	MonthlyRentsPriceGreaterThanDecision(state, getters) {
		if (
			getters.MonthlyRentsPriceGreaterThanActual
			&& state.result['monthly_rents_price_gt']
			&& state.result['monthly_rents_price_gt'] !== ''
		) {
			return +getters.MonthlyRentsPriceGreaterThanActual
				> +state.result['monthly_rents_price_gt']
				? 'Purchase'
				: 'Pass';
		}
		return '';
	},
	OpETaInsMonthlyRentsLowerThanActual(state, getters) {
		const E10 = +getters.TotalRevenues;
		const E21 = +getters.TotalOperatingExpensesCosts;
		const E25 = +getters.EscrowTaxes;
		const E27 = +state.result['escrow_hazard_insurance'];
		const E33 = +getters.PMIExpense;
		return (100 * SUM([
			E21, E25, E27, E33
		])) / E10;
	},
	OpETaInsMonthlyRentsLowerThanDecision(state, getters) {
		if (
			getters.OpETaInsMonthlyRentsLowerThanActual
			&& state.result['opex_tax_ins_monthly_rents_lt']
			&& state.result['opex_tax_ins_monthly_rents_lt'] !== ''
		) {
			return +getters.OpETaInsMonthlyRentsLowerThanActual
				< +state.result['opex_tax_ins_monthly_rents_lt']
				? 'Purchase'
				: 'Pass';
		}
		return '';
	},
	CapRateGreaterThanActual(state, getters) {
		const B5 = +state.result['home_price'];
		const E10 = +getters.TotalRevenues;
		const E21 = +getters.TotalOperatingExpensesCosts;
		const E25 = +getters.EscrowTaxes;
		const E26 = +state.result['escrow_homeowners_insurance'];
		const E27 = +state.result['escrow_hazard_insurance'];
		const E33 = +getters.PMIExpense;

		return (100 * ((E10 - E21 - E25 - E26 - E27 - E33) * 12)) / B5;
	},
	CapRateGreaterThanDecision(state, getters) {
		if (
			getters.CapRateGreaterThanActual
			&& state.result['gap_rate_gt']
			&& state.result['gap_rate_gt'] !== ''
		) {
			return +getters.CapRateGreaterThanActual > +state.result['gap_rate_gt']
				? 'Purchase'
				: 'Pass';
		}
		return '';
	},
	CashReservesAtLeastxMortgageAfterPurchaseActual(state, getters) {
		const B59 = state.constants['your_current_savings'];
		const B6 = +state.result['downpayment'] / 100;
		const B11 = +state.result['interest_rate'] / 100;
		const B13 = +getters.ofPayments;
		const E10 = +getters.TotalRevenues;
		const B49 = +state.constants['back_end_debt_ratio'] / 100;
		const B51 = +state.constants['rent_revenue_adjustment_by_banks'] / 100;

		const B58 = +state.constants['your_current_annual_salary'] / 12;
		const C72 = SUM([
			+state.constants['car_note_monthly_payment'],
			+state.constants['credit_card_payments'],
			+state.constants['first_home_month_mortgage_payment'],
			+state.constants['other_debt_monthly_payment'],
			+state.constants['student_loans_monthly_payment']
		]);
		const E34 = +getters.MonthlyPaymentWPMI;
		const C70 = B58 + B51 * E10;
		const C79 = B49 * C70 - C72;
		const C80 = -PV(B11 / 12, B13, C79);
		const C81 = C80 / (1 - B6) - C80;
		const C85 = B59 - C81;

		return C85 / E34;
	},
	CashReservesAtLeastxMortgageAfterPurchaseDecision(state, getters) {
		if (
			getters.CashReservesAtLeastxMortgageAfterPurchaseActual
			&& state.result['cash_reserves_coef']
			&& state.result['cash_reserves_coef'] !== ''
		) {
			return +getters.CashReservesAtLeastxMortgageAfterPurchaseActual
				> +state.result['cash_reserves_coef']
				? 'Purchase'
				: 'Pass';
		}
		return '';
	},
	BeatTheStockMarketsExpectedROIofActual(state, getters) {
		const E10 = +getters.TotalRevenues;
		const E21 = +getters.TotalOperatingExpensesCosts;
		const E34 = +getters.MonthlyPaymentWPMI;
		const B23 = +getters.TotalUpfrontInvestment;
		return (100 * (12 * SUM([
			E10, -E21, -E34
		]))) / B23;
	},
	BeatTheStockMarketsExpectedROIofDecision(state, getters) {
		if (
			getters.BeatTheStockMarketsExpectedROIofActual
			&& state.result['beat_roi_of']
			&& state.result['beat_roi_of'] !== ''
		) {
			return +getters.BeatTheStockMarketsExpectedROIofActual
				> +state.result['beat_roi_of']
				? 'Purchase'
				: 'Pass';
		}
		return '';
	},
};

export { gettersPurchaseOrPass };
